import React, { Suspense, useMemo } from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from 'react-router-dom';
import qs from 'qs';
import appRoutes from './appRoutes';
import Page from './pages/components/page';
import { decorateUser } from './user';
import ReactAgentSpa from './ReactAgentSpa';
import Flyout from './headersegment/flyout';
import { Provider } from 'react-redux';
import store from './redux/store';

// this custom hook allows access to query parameters from the request url
// based on this: https://v5.reactrouter.com/web/example/query-parameters

interface AppProps {
  user: any;
  aav1Host: string;
  locals?: {
    preloadData?: {
      brandingImageUrl?: string;
    };
  };
  resolutions: Record<string, unknown>;
}

const App: React.FC<AppProps> = ({ user, aav1Host, locals, resolutions }) => {
  const decoratedUser = decorateUser(user);
  const container = document.getElementById('reactApp');
  ReactAgentSpa({ user: decoratedUser, aav1Host, locals, resolutions });

  if (!container) {
    return null;
  }

  // const root = createRoot(container);

  ReactDOM.render(
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/issues/flyout" element={<Flyout />} />
          <Route path="/" element={<Navigate to="/home" />} />
          {appRoutes
            .map((route) => {
              const {
                path,
                title,
                Content,
                HelpPageComponent,
                helperFlag,
                supportFlag
              } = route;
              return (
                <Route
                  key={path}
                  path={path}
                  element={
                    <Provider store={store}>
                      <Page
                        Content={Content}
                        HelpPageComponent={HelpPageComponent}
                        path={path}
                        title={title}
                        helperFlag={helperFlag}
                        supportFlag={supportFlag}
                      />
                    </Provider>
                  }
                />
              );
            })}
        </Routes>
      </Suspense>
    </Router>,
    container,
  );

  return null;
};

declare global {
  interface Window {
    App: any;
  }
}

window.App = App;

export default App;